// Readers
import partKitReader from '@tekion/tekion-base/readers/PartKit';

// Constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Configs
import PART_OPTION_CONFIG from './partOptionConfig';
import PART_KIT_OPTION_CONFIG from './partKitOptionConfig';
var isOptionPartKit = function isOptionPartKit(option) {
  return partKitReader.beanType(option) === 'partKit';
};
var getOptionLabel = function getOptionLabel() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var isPartKit = isOptionPartKit(option);
  if (isPartKit) {
    return PART_KIT_OPTION_CONFIG.getOptionLabel(option);
  }
  return PART_OPTION_CONFIG.getOptionLabel(option);
};
var getOptionValue = function getOptionValue() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var isPartKit = isOptionPartKit(option);
  if (isPartKit) {
    return PART_KIT_OPTION_CONFIG.getOptionValue(option);
  }
  return PART_OPTION_CONFIG.getOptionValue(option);
};
var PART_AND_PART_KIT_CONFIG = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};
export default PART_AND_PART_KIT_CONFIG;